/**
 * One rule for figures on every dashboard (QA, 9 Oct 2026): a value is a whole
 * number; the "%" sign belongs to participation and cyber-risk prevalence only.
 * Readiness and Context & Support scores (composite, area, item) never carry
 * it — nor do their benchmarks, tooltips or KPI subtitles.
 */
export const UNIT = {SCORE: 'score', PERCENT: 'percent'};

/** The number in a value that may arrive as 63, "63", "63.4" or "63%"; null when there is none. */
export const toNumber = (v) => {
    if (v === null || v === undefined || v === '') return null;
    const n = typeof v === 'string' ? Number(v.replace(/%\s*$/, '').trim()) : Number(v);
    return Number.isFinite(n) ? n : null;
};

/** A figure as the dashboards show it: whole number (truncated, like `whole`), "%" only for a percent, "—" when absent. */
export const fmtValue = (v, unit = UNIT.SCORE) => {
    const n = toNumber(v);
    if (n === null) return '—';
    const w = Math.trunc(n);
    return unit === UNIT.PERCENT ? `${w}%` : String(w);
};

/** "Global avg: 54" / "Global avg: 76%" — a benchmark tooltip in the unit of the bar it sits on. */
export const benchmarkText = (name, v, unit = UNIT.SCORE) => `${name}: ${fmtValue(v, unit)}`;

/** A column header that names its unit, where the QA asked for it: "Any Cyber Risk (%)", "Readiness Composite (score)". */
export const headerLabel = (label, unit) => {
    if (unit === UNIT.PERCENT) return `${label} (%)`;
    if (unit === UNIT.SCORE) return `${label} (score)`;
    return label;
};

/** The unit of a TableCard column: the datahouse marks percentages with column_type "percent". */
export const unitOfColumn = (col) => (col?.column_type === 'percent' ? UNIT.PERCENT : UNIT.SCORE);
